import { I as Icon, _ as _taggedTemplateLiteral } from './Icon-1198e736.js';
import { useId, createElement } from 'react';
import uniqueId from 'lodash/uniqueId';
import { svgWithValues } from 'nicollet-react-utilities';
import 'styled-components';

function _templateObject() {
  var data = _taggedTemplateLiteral(["<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M12 23.5C5.649 23.5.5 18.351.5 12S5.649.5 12 .5 23.5 5.649 23.5 12 18.351 23.5 12 23.5z\" fill=\"#F7F7F7\"/><path fill=\"#333\" fill-rule=\"nonzero\" d=\"M17.244 7.816L13.061 12l4.183 4.185-1.06 1.06L12 13.06l-4.184 4.184-1.06-1.06 4.183-4.185-4.183-4.183 1.06-1.06L12 10.938l4.184-4.182z\"/></g></svg>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var svgData = svgWithValues(_templateObject());
var svgMetadata = {
  "width": 24,
  "height": 24,
  "id": "NavigationCloseCircle",
  "monochrome": false,
  "grayscale": true,
  "fullColor": false,
  "fills": ["#000000", "#f7f7f7", "#333333"],
  "nameComponents": {
    "name": "CloseCircle",
    "category": "Navigation",
    "variant": null
  }
};

var IconNavigationCloseCircle = function IconNavigationCloseCircle(props) {
  var _props$id;

  var finalSVGData = svgData({
    idPrefix: ((_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : typeof useId !== 'undefined') ? "nds-Icon".concat(useId()) : // TODO: after migrating to react@18 remove fallback usage of lodash.uniqueId as it causes hydration issues
    uniqueId('nds-Icon')
  });
  return createElement(Icon, Object.assign({}, props, {
    svgData: finalSVGData,
    svgMetadata: svgMetadata
  }));
};

IconNavigationCloseCircle.metadata = svgMetadata;
IconNavigationCloseCircle.displayName = 'IconNavigationCloseCircle';

export { IconNavigationCloseCircle };
